import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const IconBubble = ({ icon, bg, color }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 24,
      height: 24,
      borderRadius: 6,
      background: bg,
      marginRight: 9,
      flexShrink: 0,
    }}
  >
    <FontAwesomeIcon icon={icon} style={{ color, fontSize: 11 }} />
  </span>
);

export default IconBubble;
